import { inject } from '@vakantiesnl/services/src/util/template';

export function getCanonicalUrl(contentFullCanonical: string, slug: string): string {
	return inject(contentFullCanonical, { query: slug }).join('');
}
